import * as React from 'react'

function SvgHu(props) {
	return (
		<svg viewBox="0 0 6 3" width="1em" height="1em" {...props}>
			<path fill="#436F4D" d="M0 0h6v3H0z" />
			<path fill="#FFF" d="M0 0h6v2H0z" />
			<path fill="#CD2A3E" d="M0 0h6v1H0z" />
		</svg>
	)
}

export default SvgHu
